enum EnumLanguage {
	RU = 'ru',
	EN = 'en',
	DE = 'de',
}

export default EnumLanguage;
